import React from 'react';
import Head from 'next/head';

import { OrganizationSchemaProps } from './organizations-schema.types';

export const OASOrganizationSchema: React.FC<OrganizationSchemaProps> = ({ fields }) => {
  return fields ? (
    <Head>
      <script
        key="organizationSchemaScript"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(fields) }}
      ></script>
    </Head>
  ) : null;
};
